import { render } from "./consulta_parametro.vue?vue&type=template&id=d2a72afe"
import script from "./consulta_parametro.vue?vue&type=script&lang=js"
export * from "./consulta_parametro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__